export default __webpack_public_path__ + "static/media/plain-sticker-W.c137422d.png";